import React from 'react'

const HighlightText = ({text}) => {
  return (
    <span className='font-bold gradient-text'>
        {" "}
        {text}
        {" "}
    </span>
  )
}

export default HighlightText
